import {setPaddingSection} from "../../../../client/utils/padding-section";

class masterHeadPadding{
    constructor() {
        this.element = document.querySelector('#ecf-masthead-gen .box-detail-masthead')
    }
    init(){
        const ELEMENT = this.element;
        if(ELEMENT){
            let dataPadding = ELEMENT.getAttribute('data-padding');
            let dataResponsivePadding = ELEMENT.getAttribute('data-responsive');
            let obj_pd = JSON.parse(atob(dataPadding))
            let obj_responsive_pd = JSON.parse(atob(dataResponsivePadding))
            setPaddingSection(obj_pd, obj_responsive_pd, ELEMENT);
        }
    }
}
export default masterHeadPadding